export default "__VITE_ASSET__caf6d1e9__"